<template>
  <div>
    <vs-row>
      <vs-col
        v-for="(board, index) in paginatedBoards"
        :key="index"
        class="w-full md:w-1/2 lg:w-1/3 xl:w-1/3 mb-base px-4"
      >
        <board-card :title="board.title" :boardData="board"></board-card>
      </vs-col>
    </vs-row>

    <vs-pagination
      v-show="paginatedBoards.length > 1"
      class="relative"
      :total="Math.ceil(paginatedBoards.length / 11)"
      v-model="currentPage"
    ></vs-pagination>
  </div>
</template>
<script>
import BoardCard from "../../components/BoardCard.vue";
export default {
  name: "ArchivedBoards",
  components: {
    BoardCard,
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    allArchivedBoards() {
      if (this.$store.state.boards.allArchivedBoards)
        return this.$store.state.boards.allArchivedBoards;
      return [];
    },
    paginatedBoards() {
      return this.allArchivedBoards.slice(
        11 * (this.currentPage - 1),
        11 * this.currentPage
      );
    },
  },
  watch: {
    orgData(newVal) {
      if (newVal) {
        this.$store.dispatch("boards/fetchAllArchivedBoards", this.orgData._id);
      }
    },
  },
  mounted() {
    //fetch current organization
    if (this.orgData && this.orgData._id) {
      this.$store.dispatch("boards/fetchAllArchivedBoards", this.orgData._id);
    }
  },
};
</script>
